import React, { useState } from 'react';
import {
  Box, TextField, Button, Grid, FormControl,
  InputLabel, Select, MenuItem, Typography
} from '@mui/material';
import { toast } from 'react-toastify';

const DemoForm = ({ oportunidad, onGuardado, onTransicionCompleta }) => {
  const [formData, setFormData] = useState({
    fecha_demo: oportunidad?.demo_detalle?.fecha_demo || '',
    resultado: oportunidad?.demo_detalle?.resultado || '',
    notas: oportunidad?.demo_detalle?.notas || '',
    proximo_paso: oportunidad?.demo_detalle?.proximo_paso || ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fecha_demo) {
      toast.error('La fecha de demo es requerida');
      return;
    }
    if (!formData.resultado) {
      toast.error('El resultado de la demo es requerido');
      return;
    }

    try {
      await onGuardado(formData);
      toast.success('Demo registrada correctamente');
      if (onTransicionCompleta) onTransicionCompleta();
    } catch (error) {
      console.error('Error al guardar demo:', error);
      toast.error('Error al guardar los datos de la demo');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
      <Box sx={{ mb: 3, textAlign: 'center' }}>
        <Typography variant="h6" fontWeight="bold" color="primary">
          🎯 Demo / Presentación
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Registra los detalles de la demo realizada con el prospecto
        </Typography>
      </Box>

      <Grid container spacing={2}>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            required
            size="small"
            label="Fecha de la demo"
            name="fecha_demo"
            type="date"
            value={formData.fecha_demo}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="small" required>
            <InputLabel>Resultado</InputLabel>
            <Select
              value={formData.resultado}
              name="resultado"
              label="Resultado"
              onChange={handleChange}
            >
              <MenuItem value="exitosa">Exitosa — cliente interesado</MenuItem>
              <MenuItem value="positiva">Positiva — requiere más info</MenuItem>
              <MenuItem value="neutral">Neutral — sin decisión clara</MenuItem>
              <MenuItem value="negativa">Negativa — cliente no interesado</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            label="Próximo paso acordado"
            name="proximo_paso"
            value={formData.proximo_paso}
            onChange={handleChange}
            placeholder="Ej: Enviar propuesta, Reunión con decisor, Prueba de 30 días..."
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            label="Notas de la demo"
            name="notas"
            multiline
            rows={3}
            value={formData.notas}
            onChange={handleChange}
            placeholder="Observaciones, preguntas del cliente, objeciones detectadas..."
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              mt: 1,
              py: 1.5,
              fontWeight: 'bold',
              bgcolor: '#06b6d4',
              '&:hover': { bgcolor: '#0891b2' }
            }}
          >
            Registrar Demo y Avanzar
          </Button>
        </Grid>

      </Grid>
    </Box>
  );
};

export default DemoForm;
